/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ComputeAccessCreate,
  ComputeAccessCreate$inboundSchema,
  ComputeAccessCreate$Outbound,
  ComputeAccessCreate$outboundSchema,
} from "./computeaccesscreate.js";
import {
  ComputeContainerCreate,
  ComputeContainerCreate$inboundSchema,
  ComputeContainerCreate$Outbound,
  ComputeContainerCreate$outboundSchema,
} from "./computecontainercreate.js";
import {
  ComputeLimits,
  ComputeLimits$inboundSchema,
  ComputeLimits$Outbound,
  ComputeLimits$outboundSchema,
} from "./computelimits.js";
import {
  ComputePlacement,
  ComputePlacement$inboundSchema,
  ComputePlacement$Outbound,
  ComputePlacement$outboundSchema,
} from "./computeplacement.js";
import {
  ComputeRequest,
  ComputeRequest$inboundSchema,
  ComputeRequest$Outbound,
  ComputeRequest$outboundSchema,
} from "./computerequest.js";
import {
  ComputeServiceInput,
  ComputeServiceInput$inboundSchema,
  ComputeServiceInput$Outbound,
  ComputeServiceInput$outboundSchema,
} from "./computeserviceinput.js";

export type ComputeResourceCreate = {
  access?: ComputeAccessCreate | undefined;
  compute: ComputeRequest;
  container: ComputeContainerCreate;
  limits?: ComputeLimits | undefined;
  name?: string | undefined;
  placement?: ComputePlacement | undefined;
  service?: ComputeServiceInput | undefined;
};

/** @internal */
export const ComputeResourceCreate$inboundSchema: z.ZodType<
  ComputeResourceCreate,
  z.ZodTypeDef,
  unknown
> = z.object({
  access: ComputeAccessCreate$inboundSchema.optional(),
  compute: ComputeRequest$inboundSchema,
  container: ComputeContainerCreate$inboundSchema,
  limits: ComputeLimits$inboundSchema.optional(),
  name: z.string().optional(),
  placement: ComputePlacement$inboundSchema.optional(),
  service: ComputeServiceInput$inboundSchema.optional(),
});
/** @internal */
export type ComputeResourceCreate$Outbound = {
  access?: ComputeAccessCreate$Outbound | undefined;
  compute: ComputeRequest$Outbound;
  container: ComputeContainerCreate$Outbound;
  limits?: ComputeLimits$Outbound | undefined;
  name?: string | undefined;
  placement?: ComputePlacement$Outbound | undefined;
  service?: ComputeServiceInput$Outbound | undefined;
};

/** @internal */
export const ComputeResourceCreate$outboundSchema: z.ZodType<
  ComputeResourceCreate$Outbound,
  z.ZodTypeDef,
  ComputeResourceCreate
> = z.object({
  access: ComputeAccessCreate$outboundSchema.optional(),
  compute: ComputeRequest$outboundSchema,
  container: ComputeContainerCreate$outboundSchema,
  limits: ComputeLimits$outboundSchema.optional(),
  name: z.string().optional(),
  placement: ComputePlacement$outboundSchema.optional(),
  service: ComputeServiceInput$outboundSchema.optional(),
});

export function computeResourceCreateToJSON(
  computeResourceCreate: ComputeResourceCreate,
): string {
  return JSON.stringify(
    ComputeResourceCreate$outboundSchema.parse(computeResourceCreate),
  );
}
export function computeResourceCreateFromJSON(
  jsonString: string,
): SafeParseResult<ComputeResourceCreate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeResourceCreate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeResourceCreate' from JSON`,
  );
}
